module.exports = __webpack_public_path__ + "img/honor3.af2baa11.png";